module.exports = __webpack_public_path__ + "static/media/Kapitell_tn.fbd91688.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Kapitell_tn.jpg
// module id = 760
// module chunks = 0